import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

import { QueryClientProvider } from "@oneapp/data";
import { queryClient } from "./lib/queryClient";
import { ThemeProvider } from "@repo/tokens";
// import { ThemeDebugFab } from "./components/ThemeDebugFab.tsx";
import { resolveInitialTheme } from "./lib/resolveInitialTheme.ts";
import { ToastProvider } from "@repo/ui";
import { initSentry } from "./sentry.ts";
import { initializeApi } from "./lib/setupApi";
import { initLsqSqsEvents } from "./lib/initLsqSqsEvents";
import { useFeatureStore } from "./store/useFeatureStore";
import "./i18n";
import { AgoraProvider } from "./pages/agora/context-api/index.tsx";
import { initAnalytics } from "./lib/setupAnalytics";
import {
  parseLink,
  parseSignupReferralDeeplink,
} from "./components/deeplink/parseLink";
import { registerChunkLoadRecovery } from "./lib/chunkLoadRecovery";
import { bootstrapInfinityLearnHandoff } from "./lib/infinityLearnHandoff";

initSentry();
registerChunkLoadRecovery();
initializeApi();
initLsqSqsEvents();
initAnalytics();
useFeatureStore.getState().init();

const WEB_DEEPLINK_URL_STORAGE_KEY = "web_deeplink_url";

const captureInitialDeeplinkUrl = () => {
  try {
    const incomingUrl = window.location.href;
    const isDeepLink =
      parseLink(incomingUrl) !== null ||
      parseSignupReferralDeeplink(incomingUrl) !== null;
    if (!isDeepLink) return;
    localStorage.setItem(WEB_DEEPLINK_URL_STORAGE_KEY, incomingUrl);
  } catch {
    // ignore storage/URL parsing errors
  }
};

function renderApp() {
  const rootEl = document.getElementById("root");
  if (!rootEl) return;

  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider initialTheme={resolveInitialTheme()}>
          <ToastProvider>
            <AgoraProvider>
              <App />
              {/* {import.meta.env.DEV ? <ThemeDebugFab /> : null} */}
            </AgoraProvider>
          </ToastProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

async function bootstrapAndRender() {
  captureInitialDeeplinkUrl();

  try {
    await bootstrapInfinityLearnHandoff();
  } catch (error) {
    console.warn("[IL Handoff] Bootstrap failed:", error);
  }

  renderApp();
}

void bootstrapAndRender();
